import type { RecordView } from '@kit/sync/types/record-view';
import { useRecords } from '@/entities/shared/record/use-records';
import type { Note } from '../schemas/note';

export function useNotes(): RecordView<Note>[] | undefined {
  return useRecords<Note>('notes');
}
